import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'

Vue.use(ElementUI);
Vue.prototype.http = axios

Vue.config.productionTip = false
    /* 路由发生变化修改页面title */
document.title = '漆面保护膜报价查询系统';
new Vue({
    render: h => h(App),
}).$mount('#app')